export const ru = {
    'banner-id': '№ {id}'
};
